import { render } from "./UploadModuleProperties.vue?vue&type=template&id=09e6da50&scoped=true"
import script from "./UploadModuleProperties.vue?vue&type=script&lang=js"
export * from "./UploadModuleProperties.vue?vue&type=script&lang=js"

import "./UploadModuleProperties.vue?vue&type=style&index=0&id=09e6da50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e6da50"]])

export default __exports__